<template>
  <div style="display: flex; flex-shrink: 1; min-width: 0; flex-grow: 1;">
    <div ref="visibleItems" style="display: flex; flex-shrink: 1; min-width: 0; flex-grow: 1;">
      <slot name="visibleItems"
            v-bind:visibleItems="visibleItems"
      >
        <ul style="display: flex; flex-shrink: 1; overflow: hidden; flex-grow: 1;" ref="ul">
          <li style="white-space: nowrap;">
            <a href="#">Item</a>
          </li>
        </ul>
      </slot>
    </div>
    <div style="flex-shrink: 0" ref="button">
      <slot name="button" v-bind:hiddenItems="hiddenItems">
        <button>Menu</button>
      </slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    items: Array,
    minItems: Number,
  },
  data: function () {
    return {
      //internalMinItems: Math.min(this.minItems ? this.minItems : 2, this.items.length),
      internalMinItems: 0,
      visibleItems: [],
      hiddenItems: [],
      currentWidth: 0,
      containerWidth: 0,
      contentWidth: 0,
    }
  },
  mounted() {
    this.reRender();
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      setTimeout(() => {
        this.reRender();
      }, 1)
    },
    setButtonVisibility() {
      if (this.hiddenItems.length) {
        this.$refs.button.style.display = 'flex';
      } else {
        this.$refs.button.style.display = 'none';
      }
    },
    processIndex(index) {

      let item = this.items[index];

      this.visibleItems.push(item);

      Vue.nextTick(() => {
        this.processIndex2(index, item);
      })
    },
    processIndex2(index, item) {
      let containerElement = this.$refs.visibleItems;
      let containerWidth = containerElement.offsetWidth;

      let contentWidth = containerElement.childNodes[0].offsetWidth;

      console.log(containerWidth)
      console.log(contentWidth)

      if (contentWidth > containerWidth) {
        this.visibleItems.pop();
        this.hiddenItems.push(item);
      }

      if (this.items.length > index + 1) {
        this.processIndex(index + 1);
      } else {
        this.setButtonVisibility();
      }

    },
    reRender() {
      this.visibleItems = [];
      this.hiddenItems = [];
      this.currentWidth = 0;
      this.containerWidth = 0;
      this.contentWidth = 0;

      if (this.items.length) {
        this.processIndex(0);
      }


        //this.setButtonVisibility();

    }
  }
}
</script>